module.exports = __webpack_public_path__ + "static/media/noticePeriod.85002054.svg";